import React from 'react';
export var TABLE_HEAD = 'thead';
export var TABLE_FOOT = 'tfoot';
export var TableSectionContext = React.createContext({
  data: {}
});